<app-card-medium title="{{ 'Drones' | translate }}" redirectRoute="/drones/create"
    redirectLabel="{{ 'Create a Drone' | translate }}" [hasAction]="true">
    <div class="content scrollable">
        <div *ngFor="let drone of drones; trackById">
            <app-card-drone [redirectUrl]="'edit/' + drone.id" [data]="drone"></app-card-drone>
        </div>
    </div>
</app-card-medium>